import { createWebHistory, createRouter } from "vue-router";
import TheIndex from "@/components/pages/TheIndex.vue";
import TheLogin from "@/components/authentication/TheLogin.vue";
import TheLogout from "@/components/authentication/TheLogout.vue";
import TheChangePassword from "@/components/authentication/TheChangePassword.vue";

import ThePreloader from "@/components/shared/ThePreloader.vue";
import TheAdminLayout from "@/components/shared/TheAdminLayout.vue";
import TheUserLayout from "@/components/shared/TheUserLayout.vue";
import TheError404 from "@/components/pages/TheError404.vue";
import TheNoPermission from "@/components/pages/TheNoPermission.vue";

import TheOperatingCenter from "@/components/pages/user/TheOperatingCenter.vue";
import TheOperatingCenter2 from "@/components/pages/user/TheOperatingCenter2.vue";
import TheReportViewer from "@/components/pages/user/TheReportViewer.vue";
import TheMobileReportViewer from "@/components/pages/user/TheMobileReportViewer.vue";


import TheAdminIndex from "@/components/pages/admin/TheAdminIndex.vue";
import TheDashBoard from "@/components/pages/admin/TheDashboard.vue";
import TheUser from "@/components/pages/admin/TheUser.vue";
import TheRole from "@/components/pages/admin/TheRole.vue";
import TheMenu from "@/components/pages/admin/TheMenu.vue";
import TheRoleMenu from "@/components/pages/admin/TheRoleMenu.vue";
import TheWorkspace from "@/components/pages/admin/TheWorkspace.vue";
import TheUserWorkspace from "@/components/pages/admin/TheUserWorkspace.vue";
import TheRoleWorkspace from "@/components/pages/admin/TheRoleWorkspace.vue";
import TheRoleReport from "@/components/pages/admin/TheRoleReport.vue";
import TheReport from "@/components/pages/admin/TheReport.vue";
import TheDataset from "@/components/pages/admin/TheDataset.vue";
import ThePentahoErrorJob from "@/components/pages/admin/ThePentahoErrorJob.vue";
import ThePentahoJobRunInday from "@/components/pages/admin/ThePentahoJobRunInday.vue";

import menuService from "@/services/menu.service";

import { authenticationService } from "@/services/authentication.service";
import pbiService from "@/services/pbi.service";

import { store } from "@/store";

const routes = [
  {
    path: "/",
    name: "TheIndex",
    component: TheIndex,
    props: true,
    meta: {
      authRequired: true,
      title: 'Trang chủ'
    },
  },
  // {
  //   path: "/login",
  //   name: "TheLogin",
  //   component: TheLogin,
  //   props: true,
  //   meta: {
  //     authRequired: false,
  //     title: 'Đăng nhập'
  //   },
  // },
  {
    path: "/logout",
    name: "TheLogout",
    component: TheLogout,
    props: true,
    meta: {
      authRequired: false,
      title: 'Đăng xuất'
    },
  },
  {
    path: "/change-pass",
    name: "TheChangePassword",
    component: TheChangePassword,
    props: true,
    meta: {
      authRequired: false,
      title: 'Đăng nhập'
    },
  },
  {
    path: "/no-permission",
    name: "TheNoPermission",
    component: TheNoPermission,
    props: true,
    meta: {
      authRequired: false,
      title: 'Không có quyền truy cập'
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: TheError404,
  },
  {
    path: "/preloader",
    name: "ThePreloader",
    component: ThePreloader,
    props: true,
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/user",
    name: "TheUserLayout",
    component: TheUserLayout,
    props: true,
    meta: {
      authRequired: true,
    },
    children: [
      // {
      //   path: "/user/dashboard",
      //   name: "TheDashBoard",
      //   component: TheDashBoard,
      //   props: true,
      //   meta: {
      //     authRequired: true,
      //     title: 'Dashboard'
      //   },
      // },
      {
        path: "/user/operating-center",
        name: "TheOperatingCenter",
        component: TheOperatingCenter,
        props: true,
        meta: {
          authRequired: true,
          title: 'Trung tâm điều hành'
        },
      },
      {
        path: "/user/operating-center-2",
        name: "TheOperatingCenter2",
        component: TheOperatingCenter2,
        props: true,
        meta: {
          authRequired: true,
          title: 'Trung tâm điều hành'
        },
      },
    ]
  },
  {
    path: "/report-viewer",
    name: "TheReportViewer",
    component: TheReportViewer,
    props: true,
    meta: {
      authRequired: true
    },
  },
  {
    path: "/mobile-report-viewer",
    name: "TheMobileReportViewer",
    component: TheMobileReportViewer,
    props: true,
    meta: {
      authRequired: false
    },
  },
  {
    path: "/admin",
    name: "TheAdminLayout",
    component: TheAdminLayout,
    props: true,
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "/admin/",
        name: "TheAdminIndex",
        parentName: "TheShareCategory",
        component: TheAdminIndex,
        props: true,
        meta: {
          authRequired: true,
          title: 'Trang chủ'
        }
      },
      {
        path: "/admin/dashboard",
        name: "TheDashBoard",
        component: TheDashBoard,
        props: true,
        meta: {
          authRequired: true,
          title: 'Dashboard'
        },
      },
      // {
      //   path: "/admin/user",
      //   name: "TheUser",
      //   parentName: "TheShareCategory",
      //   component: TheUser,
      //   props: true,
      //   meta: {
      //     authRequired: true,
      //     title: 'Quản lý người dùng'
      //   }
      // },
      {
        path: "/admin/role",
        name: "TheRole",
        parentName: "TheShareCategory",
        component: TheRole,
        props: true,
        meta: {
          authRequired: true,
          title: 'Quản lý phân quyền'
        }
      },
      {
        path: "/admin/menu",
        name: "TheMenu",
        parentName: "TheShareCategory",
        component: TheMenu,
        props: true,
        meta: {
          authRequired: true,
          title: 'Quản lý menu'
        }
      },
      {
        path: "/admin/role-menu",
        name: "TheRoleMenu",
        parentName: "TheShareCategory",
        component: TheRoleMenu,
        props: true,
        meta: {
          authRequired: true,
          title: 'Phân quyền menu'
        }
      },
      {
        path: "/admin/workspace",
        name: "TheWorkspace",
        parentName: "TheShareCategory",
        component: TheWorkspace,
        props: true,
        meta: {
          authRequired: true,
          title: 'Quản lý workspace'
        }
      },
      {
        path: "/admin/role-workspace",
        name: "TheRoleWorkspace",
        parentName: "TheShareCategory",
        component: TheRoleWorkspace,
        props: true,
        meta: {
          authRequired: true,
          title: 'Phân quyền workspace'
        }
      },
      {
        path: "/admin/role-report",
        name: "TheRoleReport",
        parentName: "TheShareCategory",
        component: TheRoleReport,
        props: true,
        meta: {
          authRequired: true,
          title: 'Phân quyền report'
        }
      },
      {
        path: "/admin/user-workspace",
        name: "TheUserWorkspace",
        parentName: "TheShareCategory",
        component: TheUserWorkspace,
        props: true,
        meta: {
          authRequired: true,
          title: 'Phân quyền workspace'
        }
      },
      {
        path: "/admin/report",
        name: "TheReport",
        parentName: "TheShareCategory",
        component: TheReport,
        props: true,
        meta: {
          authRequired: true,
          title: 'Quản lý report'
        }
      },
      {
        path: "/admin/dataset",
        name: "TheDataset",
        parentName: "TheShareCategory",
        component: TheDataset,
        props: true,
        meta: {
          authRequired: true,
          title: 'Quản lý dataset'
        }
      },
      {
        path: "/admin/pentaho-error-job",
        name: "ThePentahoErrorJob",
        parentName: "TheShareCategory",
        component: ThePentahoErrorJob,
        props: true,
        meta: {
          authRequired: true,
          title: 'Danh sách job lỗi'
        }
      },
      {
        path: "/admin/pentaho-job-run-inday",
        name: "ThePentahoJobRunInday",
        parentName: "TheShareCategory",
        component: ThePentahoJobRunInday,
        props: true,
        meta: {
          authRequired: true,
          title: 'Danh sách job thực thi trong ngày'
        }
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  let user = JSON.parse(localStorage.getItem("login_info"));
  let loggedIn = user && Date.parse(user.expiresTime) > Date.now() ? true : false;
  let authPage = to.meta.authRequired;

  if(authPage) {
    if (!loggedIn) {
      let loginId = to.query.login;
      if(loginId) {
        await authenticationService.getLoginInfoFromSSO(loginId);
        next("/admin/dashboard/");
      } else {
        window.location.href = `${process.env.VUE_APP_AUTH_URL}/#/login?appId=${process.env.VUE_APP_ID}`;
      }
    } else {
      if(parseInt(user.pbiAccessToken.expires_on + '000') <= Date.now()) {
        let pbiAccessTokenRes = await pbiService.getAccessToken(user.accessToken);
        if(pbiAccessTokenRes.isOk && pbiAccessTokenRes.data.data) {
          user.pbiAccessToken = pbiAccessTokenRes.data.data;
          // lưu dữ liệu user và token jwt vào local storage để giữ user được log in trong page
          localStorage.setItem('login_info', JSON.stringify(user));
        }
      }
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  document.title = to.meta.title || 'IOC VNPT';
});

export default router;
